// BL-395: our forms subscribe server-side, which leaves the browser anonymous,
// and Klaviyo drops onsite events (like "Viewed Page") from anonymous visitors.
// Identifying the visitor here links the browser to the profile. Queued on
// `_klOnsite` for the same reason as OpenKlaviyoForm.
export const identifyVisitor = (email) => {
  if (!email || typeof window === 'undefined') return;

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['identify', { email }]);
};

export const subscribeToList = async (email, listId) => {
  try {
    const response = await fetch('/api/integrations/klaviyo/subscribe-to-list', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, listId }),
    });

    return await response.json();
  } catch {
    return { success: false, error: 'Internal server error' };
  }
};

export const trackProductSavedEvent = async (email, payload = {}) => {
  try {
    const response = await fetch('/api/integrations/klaviyo/track-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, ...payload }),
    });

    return await response.json();
  } catch {
    return { success: false, error: 'Internal server error' };
  }
};
